import merge from 'classnames';

import { SvgIconContainer } from '@/components/generic/SvgIconContainer';

import { SvgIconContainerIconProps } from '../types';

import colors from 'styles/core/colors.module.scss';

export const IconWarning = ({
  classes = {},
  color = colors.COLOR_dark,
  onClick,
}: SvgIconContainerIconProps) => (
  <SvgIconContainer className={classes.container} onClick={onClick} role="img">
    <svg
      className={merge(classes.icon)}
      data-testid="gafe-icon-warning"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" fill={color} />
    </svg>
  </SvgIconContainer>
);
